import { SolType } from '@sol/components';
import { AsmLicenseUsageTools, LicenseUsageBudget } from '../tools/asm-license-usage-tools';

export class AsmUsageType {
  public static readonly licenseUsageBudget = SolType.ofPrimitive<LicenseUsageBudget>(
    'licenseUsageBudget',
    () => ({ amount: 0, is_cents: false, unit_display_name: '' }),
    value => (value ? AsmLicenseUsageTools.formatBudget(value) : ''),
    undefined,
    SolType.string,
  );
}
